module.exports = __webpack_public_path__ + "img/Screenshot_3.0cb2a7b3.png";